<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" routerLink="/"></i>

        <span class="my-auto f16 fw-bold me-2"> داشبورد نظارتی </span>

    </div>

</div>

<div dir="rtl" class="form row gx-2 px-2 w-100 mt-2 py-1">

    <div class="row gx-2 gy-2 w-100 mt-2 ">

        <div id="chart1" class="col-12 justify-content-around d-flex row chart2 mb-5  rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> تعداد ناوگان به تفکیک پیمانکار </p>

                <canvas id="myChart1" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart2" class="col-12 justify-content-around d-flex row chart2 mb-5 rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> تعداد مدرسه به تفکیک پیمانکار </p>

                <canvas id="myChart2" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart3" class="col-12 justify-content-around d-flex row chart3 mb-5 rounded shadow mb-3">

            <div class="dirI">

                <p class="text-center f18 dirI"> تعداد دانش آموز به تفکیک پیمانکار </p>

                <canvas id="myChart3" style="max-height: 350px !important;"></canvas>

            </div>

        </div>

        <div id="chart4" class="col-12 justify-content-around d-flex row chart4 mb-5 rounded shadow mb-3">

            <div class="p-2" style="height: 600px;">

                <p class="text-center f18"> پراکندگی مدارس </p>

                <div id="map1" class="fixed-mapCluster">

                    <div class="position-absolute" id="map_tooltip" data-bs-html="true">

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>